import { LayerDefinition } from './types';

export const freezingLevelDefinition: LayerDefinition = {
  id: 'freezing_level',
  name: 'Freezing Level',
  category: 'core_met',
  categoryLabel: 'Core Meteorological',
  icon: '🧊',
  description: '0°C Isotherm altitude above Mean Sea Level.',
  sourceModels: ['hrrr', 'rrfs', 'rdps', 'gfs', 'ecmwf', 'icon13'],
  outputModels: ['Altitude (Meters MSL) .pmtiles per model'],
  config: {
    defaultModel: 'hrrr'
  }
};

export default freezingLevelDefinition;
